import { render, staticRenderFns } from "./HSCodeForm.vue?vue&type=template&id=5228a06e&scoped=true"
import script from "./HSCodeForm.vue?vue&type=script&lang=js"
export * from "./HSCodeForm.vue?vue&type=script&lang=js"
import style0 from "./HSCodeForm.vue?vue&type=style&index=0&id=5228a06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228a06e",
  null
  
)

export default component.exports